  <nz-row [nzGutter]="16" nzJustify="space-between">
    <nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label nzFor="dateRange">Date Range</nz-form-label>
        <nz-form-control>
          <nz-range-picker 
            id="dateRange" 
            [ngModel]="dateRange()" 
            (ngModelChange)="onDateRangeChange($event)" 
            name="dateRange"
            style="width: 100%;">
          </nz-range-picker>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label nzFor="searchTerm">Search</nz-form-label>
        <nz-form-control>
          <nz-input-group [nzPrefix]="searchIcon">
            <input 
              nz-input 
              id="searchTerm" 
              [ngModel]="searchTerm()" 
              (ngModelChange)="onSearchTermChange($event)" 
              name="searchTerm" 
              placeholder="Vehicle, driver, location..." />
          </nz-input-group>
          <ng-template #searchIcon>
            <span nz-icon nzType="search"></span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <nz-col [nzSpan]="4">
      <nz-form-item>
        <nz-form-control>
          <button 
            nz-button 
            nzType="default" 
            (click)="onClearFilters()" 
            [disabled]="searchTerm() == '' && !dateRange()"
            style="width: 100%;">
            Clear Filters
          </button>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>